import { useCommonUserRetrieveSuspense } from "@boundless/bl-api-client/common/services"
import { Bell } from "lucide-react"
import { useStore } from "zustand"

import { AvatarBadge } from "@/components/layout/AvatarBadge"
import { UserBadge } from "@/components/layout/UserBadge"
import { store } from "@/lib/store"
import BoundlessLogo from "@/svg/boundless/logo.svg?react"

export default function Header({ onLogout }: { onLogout: () => void }) {
  const partnerLogo = useStore(store, (state) => state.partnerLogo)

  const greeting = () => {
    const hour = new Date().getHours()
    if (hour < 12) return "Good Morning"
    if (hour < 18) return "Good Afternoon"
    return "Good Evening"
  }

  const { data: user } = useCommonUserRetrieveSuspense()

  return (
    <header className="relative flex h-20 items-center border-b">
      <div
        className="pointer-events-none absolute inset-0 z-0"
        style={{
          background: `radial-gradient(
    900px circle at calc(100% - 320px) -420px in oklch,
    oklch(from var(--header-gradient-color, var(--primary)) l c h / 55%) 15%,
    transparent 75%
  )`,
        }}
      />
      <div className="hidden h-full w-64 items-center justify-center border-r lg:flex">
        <div className="flex h-full w-full items-center justify-center px-4">
          {partnerLogo ? (
            <img
              src={partnerLogo}
              alt="Partner Logo"
              className="h-auto max-h-[70%] w-auto max-w-full shrink-0 object-contain"
            />
          ) : (
            <BoundlessLogo className="h-10 w-auto max-w-full shrink-0 object-contain" />
          )}
        </div>
      </div>
      <div className="flex min-w-0 flex-1 items-center justify-between px-4 sm:px-6">
        <div className="lg:hidden">
          <AvatarBadge user={user} />
        </div>
        <div className="flex min-w-0 flex-col px-2 lg:px-0">
          <h1 className="truncate text-sm font-medium lg:text-lg">
            {greeting()}, {user.firstName}!
          </h1>
          <p className="text-muted-foreground truncate text-xs">
            Welcome to Boundless AI
          </p>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-3">
            <div
              data-testid="notification-bell"
              className="relative flex h-12 w-12 items-center justify-center rounded-lg bg-white shadow-sm"
            >
              <Bell className="h-5 w-5 text-gray-500" />
            </div>
          </div>

          <div className="hidden lg:block">
            <UserBadge user={user} onLogout={onLogout} />
          </div>
        </div>
      </div>
    </header>
  )
}
